import _ from 'lodash';

import { NATIONAL_ORG_STATE_OPTION } from './Trustees.constants';

export const getOrgStateAbbreviation = trustee =>
  trustee?.orgState?.abbreviation ?? trustee?.orgState ?? null;

export const getAddressStateAbbreviation = address =>
  address?.state?.abbreviation ?? address?.state ?? null;

export const getOrgStateLabel = trustee =>
  getOrgStateAbbreviation(trustee) ?? NATIONAL_ORG_STATE_OPTION.name;

const getFullAddress = address => {
  if (!address) {
    return '';
  }

  const stateCode = getAddressStateAbbreviation(address);
  const cityStateZip = [address.city, stateCode, address.zipCode].filter(Boolean).join(', ');

  return [address.streetAddress, address.unit, cityStateZip].filter(Boolean).join(' ');
};

export const getSortedTrustees = trustees => {
  if (!trustees?.length) {
    return [];
  }

  const [nationalTrustees, stateTrustees] = _.partition(trustees, trustee =>
    _.isNil(getOrgStateAbbreviation(trustee)),
  );

  const orderedStateTrustees = _.orderBy(stateTrustees, [getOrgStateAbbreviation], ['asc']);

  return [...nationalTrustees, ...orderedStateTrustees];
};

export const getFormattedTableData = ({ trustees, isManageAllowed, isLoading, onEdit, onDelete }) =>
  trustees.map(trustee => ({
    ...trustee,
    orgStateLabel: getOrgStateLabel(trustee),
    addressLabel: getFullAddress(trustee.address),
    isManageAllowed,
    isLoading,
    onEdit: () => onEdit(trustee),
    onDelete: () => onDelete(trustee),
  }));
